import { AwsLogo, GCPLogo, AzureLogo, M365Logo } from 'assets';
import React from 'react';

const CloudProviderIcon = ({ cloudProviderType, size }) => {
  let iconSource;
  let altText = '';

  // Determine icon source and alt text based on cloudProviderType
  switch (cloudProviderType.toLowerCase()) {
    case 'aws':
      iconSource = AwsLogo;
      altText = 'AWS';
      break;
    case 'gcp':
      iconSource = GCPLogo;
      altText = 'GCP';
      break;
    case 'azure':
      iconSource = AzureLogo;
      altText = 'Azure';
      break;
    case 'm365':
      iconSource = M365Logo;
      altText = 'Microsoft 365';
      break;
    default:
      // If integrationType is not recognized, set a default icon
      iconSource = AwsLogo;
      altText = 'Unknown Integration Type';
  }

  // Return the appropriate icon or a default icon
  return cloudProviderType === 'other' ? (
    <i
      className="fa fa-plug"
      style={{
        color: '#0e74bc',
        fontSize: `${size}px`,
      }}
    ></i>
  ) : (
    <img width={size} height={size} src={iconSource} alt={altText} />
  );
};

export default CloudProviderIcon;
